import { Component, OnInit} from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute} from '@angular/router'
import { BaseService } from './ifc/services/base.service';
import { environment } from '../environments/environment';
import { StateService } from './ifc/services/state.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [BaseService]
})
export class AppComponent implements OnInit {
  title = 'icRewards';
  isLoading = true;
  language = "en_US";

  constructor(
    private _baseService:BaseService,
    public state: StateService,
    private activatedRoute: ActivatedRoute,
  ){
    var currentUrl = (this._baseService.platformLocation as any).location.origin + (this._baseService.platformLocation as any).pathname;
    
    // this._baseService._router.events.subscribe(event => {
    //   if (event instanceof NavigationEnd) {
    //     (<any>window).ga('set', 'page', event.urlAfterRedirects);
    //     (<any>window).ga('send', 'pageview');
    //   }
    // });

    try {
      const script = document.createElement('script');
      script.innerHTML = `
        (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
        (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
        m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
        })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

        ga('create', '` + environment.googleAnalyticsId + `', 'auto');
        ga('send', 'pageview');
      `;
      document.head.appendChild(script);
    } catch (ex) {
      console.error('Error appending google analytics');
      console.error(ex);
    }

    if (environment.production) {
      window.console.log = function () { };  
    }

  }
  
  async ngOnInit(){
    this.language = this.state.getLanguage();
    this.state.setLanguage(this.language);
    this.isLoading = false;
  }
  
}
